import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const redirect = params.get("redirect") || "/espace";
  const justReset = params.get("reset") === "1";

  useEffect(() => {
    if (justReset) {
      toast.success("Mot de passe mis à jour. Connectez-vous avec votre nouveau mot de passe.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Connecté");
      nav(u.role === "admin" ? "/admin" : redirect, { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cs-cream min-h-[80vh] py-16" data-testid="page-login">
      <div className="max-w-md mx-auto px-6">
        <div className="cs-eyebrow text-neutral-500">Espace client</div>
        <h1 className="cs-h1 mt-3 text-5xl">Connexion.</h1>
        <form className="mt-10 space-y-5" onSubmit={submit}>
          <div>
            <label htmlFor="login-email" className="cs-eyebrow text-neutral-500">Email</label>
            <input
              id="login-email"
              name="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="cs-input mt-2"
              data-testid="login-email"
              autoComplete="email"
            />
          </div>
          <div>
            <label htmlFor="login-password" className="cs-eyebrow text-neutral-500">Mot de passe</label>
            <input
              id="login-password"
              name="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="cs-input mt-2"
              data-testid="login-password"
              autoComplete="current-password"
            />
          </div>
          {justReset && (
            <div
              className="rounded-sm border border-[#0E7C90]/30 bg-white/60 p-3 text-sm text-neutral-700"
              data-testid="login-reset-success-banner"
            >
              Votre mot de passe a bien été réinitialisé. Connectez-vous avec votre nouveau mot de passe.
            </div>
          )}
          <button type="submit" disabled={loading} className="cs-btn-primary w-full justify-center"
            data-testid="login-submit">
            {loading ? "Connexion…" : "Se connecter"}
          </button>
          <div className="flex items-center justify-between pt-3 text-sm text-neutral-600">
            <Link
              to="/mot-de-passe-oublie"
              className="cs-link-underline text-[#0E7C90]"
              data-testid="login-forgot-password-link"
            >
              Mot de passe oublié&nbsp;?
            </Link>
            <Link
              to="/inscription"
              className="cs-link-underline text-[#0E7C90]"
              data-testid="login-register-link"
            >
              Créer un compte
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
